export const SETTINGS_ROUTES = {
  profile: '/settings/profile',
  password: '/settings/password',
  appLanguage: '/settings/app-language',
  contentLanguage: '/settings/content-language',
  notifications: '/settings/notifications',
};
